import axiosInstance from "../axiosInstance";

const UserQuery = {
  getAllPositions: async () => {
    const resp = await axiosInstance.get("/humanResource/positions");

    return resp?.data;
  },
  getPositionById: async (id) => {
    const resp = await axiosInstance.get(`/humanResource/position/${id}`);

    return resp?.data;
  },
  getAllPreviousPositions: async () => {
    const resp = await axiosInstance.get("/humanResource/previousPositions");

    return resp?.data;
  },

  jobApplication: async (formData) => {
    const resp = await axiosInstance.post(
      "/humanResource/jobApplication",
      formData
    );

    return resp?.data;
  },

  getAllCurrentTenders: async () => {
    const resp = await axiosInstance.get("/scm/currentTenders");

    return resp?.data;
  },
  getAllPreviousTenders: async () => {
    const resp = await axiosInstance.get("/scm/previousTenders");

    return resp?.data;
  },
  getAllCancelledTenders: async () => {
    const resp = await axiosInstance.get("/scm/cancelledTenders");

    return resp?.data;
  },
  getTenderById: async (id) => {
    const resp = await axiosInstance.get(`/scm/tender/${id}`);

    return resp?.data;
  },

  // Get Banners

  getAllBanners: async () => {
    const resp = await axiosInstance.get("/cse/banners");

    return resp?.data;
  },
  getAllBoardMembers: async () => {
    const resp = await axiosInstance.get("/cse/boardMembers");

    return resp?.data;
  },
  getAllCommitteeMembers: async () => {
    const resp = await axiosInstance.get("/cse/committeeMembers");

    return resp?.data;
  },
  getAllCommiteeNames: async () => {
    const resp = await axiosInstance.get("/cse/committees");

    return resp?.data;
  },
  getlAllDocumentsTitle: async () => {
    const resp = await axiosInstance.get(`/cse/downloadsTitle`);

    return resp?.data;
  },
  getAllAnnualReports: async () => {
    const resp = await axiosInstance.get("/cse/annualReports");

    return resp?.data;
  },
  getAllResearcheports: async () => {
    const resp = await axiosInstance.get("/cse/researchReports");

    return resp?.data;
  },

  // Get Notices

  getAllGeneralNotices: async () => {
    const resp = await axiosInstance.get("/cse/generalNotices");

    return resp?.data;
  },
  getAllGrantsWindows: async () => {
    const resp = await axiosInstance.get("/cse/grantWindows");

    return resp?.data;
  },

  // Gallery Images
  getAllGalleryImages: async () => {
    const resp = await axiosInstance.get("/cse/gallery");

    return resp?.data;
  },

  // Board Reflections
  getAllBoardReflections: async () => {
    const resp = await axiosInstance.get("/admin/board-reflections");

    return resp?.data;
  },
  getBoardReflectionById: async (id) => {
    const resp = await axiosInstance.get(`/admin/board-reflection/${id}`);

    return resp?.data;
  },
  addBoardReflection: async (formData) => {
    const resp = await axiosInstance.post("/admin/board-reflection", formData);

    return resp?.data;
  },
  updateBoardReflection: async (id, formData) => {
    const resp = await axiosInstance.put(
      `/admin/board-reflection/${id}`,
      formData
    );

    return resp?.data;
  },
  deleteBoardReflection: async (id) => {
    const resp = await axiosInstance.delete(`/admin/board-reflection/${id}`);

    return resp?.data;
  },

  // Lifelong Learning Events
  getAllLLEvents: async () => {
    const resp = await axiosInstance.get("/admin/ll-events");
    return resp?.data;
  },

  subscribeToNewsletter: async (formData) => {
    const resp = await axiosInstance.post("/cse/subscribeEmail", formData);

    return resp?.data;
  },

  getAllArticles: async (currentPage, articlesPerPage, searchTerm = "", category = "") => {
    const resp = await axiosInstance.get("/admin/articles/paginated", {
      params: {
        page: currentPage,
        limit: articlesPerPage,
        search: searchTerm,
        category: category
      }
    });
    return resp?.data;
  },

  getArticleById: async (id, browserId) => {
    const resp = await axiosInstance.get(
      `/admin/article/${id}?browserId=${browserId}`
    );
    return resp?.data;
  },

  incrementArticleShares: async (id) => {
    const resp = await axiosInstance.put(`/admin/article/shares/${id}`);
    return resp?.data;
  }
};

export default UserQuery;
